/* Ported from fdlibm s_erf.c */

/* @(#)s_erf.c 1.3 95/01/18 */
/*
 * ====================================================
 * Copyright (C) 1993 by Sun Microsystems, Inc. All rights reserved.
 *
 * Developed at SunSoft, a Sun Microsystems, Inc. business.
 * Permission to use, copy, modify, and distribute this
 * software is freely granted, provided that this notice
 * is preserved.
 * ====================================================
 */

const tiny = 1e-300,
  half = 5.0e-1 /* 0x3FE00000, 0x00000000 */,
  one = 1.0 /* 0x3FF00000, 0x00000000 */,
  two = 2.0 /* 0x40000000, 0x00000000 */,
  /* c = (float)0.84506291151 */
  erx = 8.45062911510467529297e-1 /* 0x3FEB0AC1, 0x60000000 */,
  /*
   * Coefficients for approximation to  erf on [0,0.84375]
   */
  efx = 1.28379167095512586316e-1 /* 0x3FC06EBA, 0x8214DB69 */,
  efx8 = 1.02703333676410069053 /* 0x3FF06EBA, 0x8214DB69 */,
  pp0 = 1.28379167095512558561e-1 /* 0x3FC06EBA, 0x8214DB68 */,
  pp1 = -3.2504210724700149937e-1 /* 0xBFD4CD7D, 0x691CB913 */,
  pp2 = -2.84817495755985104766e-2 /* 0xBF9D2A51, 0xDBD7194F */,
  pp3 = -5.77027029648944159157e-3 /* 0xBF77A291, 0x236668E4 */,
  pp4 = -2.37630166566501626084e-5 /* 0xBEF8EAD6, 0x120016AC */,
  qq1 = 3.97917223959155352819e-1 /* 0x3FD97779, 0xCDDADC09 */,
  qq2 = 6.50222499887672944485e-2 /* 0x3FB0A54C, 0x5536CEBA */,
  qq3 = 5.08130628187576562776e-3 /* 0x3F74D022, 0xC4D36B0F */,
  qq4 = 1.32494738004321644526e-4 /* 0x3F215DC9, 0x221C1A10 */,
  qq5 = -3.9602282787753681232e-6 /* 0xBED09C43, 0x42A26120 */,
  /*
   * Coefficients for approximation to  erf  in [0.84375,1.25]
   */
  pa0 = -2.36211856075265944077e-3 /* 0xBF6359B8, 0xBEF77538 */,
  pa1 = 4.14856118683748331666e-1 /* 0x3FDA8D00, 0xAD92B34D */,
  pa2 = -3.72207876035701323847e-1 /* 0xBFD7D240, 0xFBB8C3F1 */,
  pa3 = 3.18346619901161753674e-1 /* 0x3FD45FCA, 0x805120E4 */,
  pa4 = -1.10894694282396677476e-1 /* 0xBFBC6398, 0x3D3E28EC */,
  pa5 = 3.54783043256182359371e-2 /* 0x3FA22A36, 0x599795EB */,
  pa6 = -2.166375594868790843e-3 /* 0xBF61BF38, 0x0A96073F */,
  qa1 = 1.06420880400844228286e-1 /* 0x3FBB3E66, 0x18EEE323 */,
  qa2 = 5.40397917702171048937e-1 /* 0x3FE14AF0, 0x92EB6F33 */,
  qa3 = 7.18286544141962662868e-2 /* 0x3FB2635C, 0xD99FE9A7 */,
  qa4 = 1.26171219808761642112e-1 /* 0x3FC02660, 0xE763351F */,
  qa5 = 1.36370839120290507362e-2 /* 0x3F8BEDC2, 0x6B51DD1C */,
  qa6 = 1.1984499846799107417e-2 /* 0x3F888B54, 0x5735151D */,
  /*
   * Coefficients for approximation to  erfc in [1.25,1/0.35]
   */
  ra0 = -9.86494403484714822705e-3 /* 0xBF843412, 0x600D6435 */,
  ra1 = -6.93858572707181764372e-1 /* 0xBFE63416, 0xE4BA7360 */,
  ra2 = -1.05586262253232909814e1 /* 0xC0251E04, 0x41B0E726 */,
  ra3 = -6.23753324503260060396e1 /* 0xC04F300A, 0xE4CBA38D */,
  ra4 = -1.62396669462573470355e2 /* 0xC0644CB1, 0x84282266 */,
  ra5 = -1.84605092906711035994e2 /* 0xC067135C, 0xEBCCABB2 */,
  ra6 = -8.12874355063065934246e1 /* 0xC0545265, 0x57E4D2F2 */,
  ra7 = -9.81432934416914548592 /* 0xC023A0EF, 0xC69AC25C */,
  sa1 = 1.96512716674392571292e1 /* 0x4033A6B9, 0xBD707687 */,
  sa2 = 1.376577541435190426e2 /* 0x4061350C, 0x526AE721 */,
  sa3 = 4.34565877475229228821e2 /* 0x407B290D, 0xD58A1A71 */,
  sa4 = 6.45387271733267880336e2 /* 0x40842B19, 0x21EC2868 */,
  sa5 = 4.29008140027567833386e2 /* 0x407AD021, 0x57700314 */,
  sa6 = 1.08635005541779435134e2 /* 0x405B28A3, 0xEE48AE2C */,
  sa7 = 6.57024977031928170135 /* 0x401A47EF, 0x8E484A93 */,
  sa8 = -6.04244152148580987438e-2 /* 0xBFAEEFF2, 0xEE749A62 */,
  /*
   * Coefficients for approximation to  erfc in [1/.35,28]
   */
  rb0 = -9.86494292470009928597e-3 /* 0xBF843412, 0x39E86F4A */,
  rb1 = -7.99283237680523006574e-1 /* 0xBFE993BA, 0x70C285DE */,
  rb2 = -1.77579549177547519889e1 /* 0xC031C209, 0x555F995A */,
  rb3 = -1.60636384855821916062e2 /* 0xC064145D, 0x43C5ED98 */,
  rb4 = -6.37566443368389627722e2 /* 0xC083EC88, 0x1375F228 */,
  rb5 = -1.02509513161107724954e3 /* 0xC0900461, 0x6A2E5992 */,
  rb6 = -4.83519191608651397019e2 /* 0xC07E384E, 0x9BDC383F */,
  sb1 = 3.03380607434824582924e1 /* 0x403E568B, 0x261D5190 */,
  sb2 = 3.25792512996573918826e2 /* 0x40745CAE, 0x221B9F0A */,
  sb3 = 1.53672958608443695994e3 /* 0x409802EB, 0x189D5118 */,
  sb4 = 3.19985821950859553908e3 /* 0x40A8FFB7, 0x688C246A */,
  sb5 = 2.55305040643316442583e3 /* 0x40A3F219, 0xCEDF3BE6 */,
  sb6 = 4.74528541206955367215e2 /* 0x407DA874, 0xE79FE763 */,
  sb7 = -2.24409524465858183362e1; /* 0xC03670E2, 0x42712D62 */

const dataView = new DataView(new ArrayBuffer(8));

export function erf(x) {
  const sign = x >= 0 ? 1 : -1;
  x = Math.abs(x);

  if (isNaN(x)) return NaN;
  if (x === Infinity) return sign * 1;

  dataView.setFloat64(0, x);
  const ix = dataView.getInt32(0);

  if (ix < 0x3feb0000) {
    /* |x|<0.84375 */
    if (ix < 0x3e300000) {
      /* |x|<2**-28 */
      if (ix < 0x00800000)
        return sign * (0.125 * (8.0 * x + efx8 * x)); /*avoid underflow */
      return sign * (x + efx * x);
    }
    const z = x * x;
    const r = pp0 + z * (pp1 + z * (pp2 + z * (pp3 + z * pp4)));
    const s = one + z * (qq1 + z * (qq2 + z * (qq3 + z * (qq4 + z * qq5))));
    const y = r / s;
    return sign * (x + x * y);
  }
  if (ix < 0x3ff40000) {
    /* 0.84375 <= |x| < 1.25 */
    const s = x - one;
    const P =
      pa0 + s * (pa1 + s * (pa2 + s * (pa3 + s * (pa4 + s * (pa5 + s * pa6)))));
    const Q =
      one + s * (qa1 + s * (qa2 + s * (qa3 + s * (qa4 + s * (qa5 + s * qa6)))));
    return sign * (erx + P / Q);
  }
  if (ix >= 0x40180000) {
    /* inf>|x|>=6 */
    return sign * (one - tiny);
  }
  const s = one / (x * x);
  let R, S;
  if (ix < 0x4006db6e) {
    /* |x| < 1/0.35 */
    R =
      ra0 +
      s *
        (ra1 +
          s * (ra2 + s * (ra3 + s * (ra4 + s * (ra5 + s * (ra6 + s * ra7))))));
    S =
      one +
      s *
        (sa1 +
          s *
            (sa2 +
              s *
                (sa3 +
                  s * (sa4 + s * (sa5 + s * (sa6 + s * (sa7 + s * sa8)))))));
  } else {
    /* |x| >= 1/0.35 */
    R =
      rb0 + s * (rb1 + s * (rb2 + s * (rb3 + s * (rb4 + s * (rb5 + s * rb6)))));
    S =
      one +
      s *
        (sb1 +
          s * (sb2 + s * (sb3 + s * (sb4 + s * (sb5 + s * (sb6 + s * sb7))))));
  }
  dataView.setInt32(4, 0);
  const z = dataView.getFloat64(0);
  const r = Math.exp(-z * z - 0.5625) * Math.exp((z - x) * (z + x) + R / S);
  return sign * (one - r / x);
}
